import { render, staticRenderFns } from "./ReviewListFilterFlowSimulation.vue?vue&type=template&id=872ef4ec&scoped=true&"
import script from "./ReviewListFilterFlowSimulation.vue?vue&type=script&lang=js&"
export * from "./ReviewListFilterFlowSimulation.vue?vue&type=script&lang=js&"
import style0 from "./ReviewListFilterFlowSimulation.vue?vue&type=style&index=0&id=872ef4ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872ef4ec",
  null
  
)

component.options.__file = "ReviewListFilterFlowSimulation.vue"
export default component.exports